<div class="layout-wrapper" [ngClass]="{
    'layout-sidebar': app.menuMode === 'sidebar',
    'layout-static': app.menuMode === 'sidebar' && sidebarStatic,
    'layout-horizontal': app.menuMode === 'horizontal',
    'layout-rightpanel-active': rightPanelActive,
    'layout-slim': app.menuMode === 'slim',
    'layout-mobile-active': staticMenuMobileActive,
    'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple}"
    [class]="'layout-menu-'+ app.menuTheme+ ' layout-topbar-'+ app.topbarTheme" (click)="onLayoutClick()">

    <app-topbar></app-topbar>
    <p-confirmDialog  key="app-confirmDialog" [baseZIndex]="10000" rejectButtonStyleClass="p-button-outlined" ></p-confirmDialog>
    <p-toast [style]="{marginTop: '20px'}" [baseZIndex]="5000"></p-toast>
            
    <div class="layout-main">
        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>

    <div class="layout-mask modal-in"></div>
</div>
